function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.15 12.893c0-2.825 1.108-6.41 2.89-9.357.88-1.453 1.85-2.632 2.856-3.497L.002 0V21.96h13.481V13.66H8.15v-.766zm-1.926-4.59c0 .507-.398.918-.889.918-.49 0-.889-.411-.889-.918V5.548c0-.507.398-.918.89-.918.49 0 .888.411.888.918v2.755zM24.002 0l-7.18.04c-3.39 1.05-6.816 7.33-7.162 12.088h5.305v9.833l9.037.039V0zm-4.444 8.303c0 .507-.398.918-.89.918-.49 0-.888-.411-.888-.918V5.548c0-.507.398-.918.889-.918.49 0 .889.411.889.918v2.755z",
  fill: "currentColor"
});

var SvgMac = function SvgMac(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMac, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mac.e1d07226.svg";
export { ForwardRef as ReactComponent };